import { GridColumnMenuFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';
import { ComponentType, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormularyIcon from 'src/assets/icons/FormularyIcon';
import AttributeFilterUI, {
  AttributeFilterOption,
} from 'src/components/AttributeFilterUI';

const PunchoutOrderGuideAttributesFilter: ComponentType<GridColumnMenuProps> = (
  columnMenuProps
) => {
  const { t } = useTranslation();

  const punchoutOrderGuideAttributeOptions: AttributeFilterOption[] = useMemo(
    () => [
      {
        type: 'isFormulary',
        label: t('Company Specified'),
        icon: <FormularyIcon />,
      },
    ],
    [t]
  );

  return (
    <GridColumnMenuFilter
      {...columnMenuProps}
      expanded={true}
      hideSecondFilter
      filterUI={(filterUIProps) => (
        <AttributeFilterUI
          {...filterUIProps}
          attributeOptions={punchoutOrderGuideAttributeOptions}
        />
      )}
    />
  );
};

export default PunchoutOrderGuideAttributesFilter;
